import EllipsisIcon from "../../media/EllipsisIcon"
import { EllipsisMenuProps } from "./EllipsisMenu.types"
import useClickOutside from "../../hooks/useClickOutside"
import "./EllipsisMenu.css"

/**
 * Renders 3 horizontal dots ellipsis menu with given options.
 * 
 * @param items items to render on ellipsis menu
 * @param showMenu boolean to show or hide menu
 * @param onClick function to handle click event
 */
const EllipsisMenu = (props: EllipsisMenuProps) => {
  
  const { ellipsisMenu, type } = props
  const [{
    contextRef: menuRef
  }] = useClickOutside({onClickOutside: ellipsisMenu.onHide})

  return (
    <div className="ellipsis-menu" ref={menuRef}>
      <div className={`ellipsis-icon ellipsis-icon-${type}`} onClick={ellipsisMenu.onClick}>
        <EllipsisIcon />
      </div>

      {ellipsisMenu.showMenu && 
        <div className="ellipsis-menu-items">
          {ellipsisMenu.items.map((item, index) => (
            <p 
              key={index}
              className={`ellipsis-menu-item ${item.disabled === true ? "ellipsis-menu-item-disabled" : ""}`}
              onClick={item.disabled === true ? () => {} : () => item.onClick()}
            >
              {item.item}
            </p>
          ))}
        </div>
      }
    </div>
  )
}

EllipsisMenu.defaultProps = {
  type: "light"
}

export default EllipsisMenu